export class WebhookV1StandardPayloadCreditsMonthlyUsage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadCreditsMonthlyUsageArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadCreditsMonthlyUsage.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum;
(function (WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum) {
    WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum["_80"] = "CREDITS_MONTHLY_USAGE_80";
    WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum["_90"] = "CREDITS_MONTHLY_USAGE_90";
    WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum["_100"] = "CREDITS_MONTHLY_USAGE_100";
})(WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum || (WebhookV1StandardPayloadCreditsMonthlyUsageTypeEnum = {}));
